<template>
    <div class="graph-container">
        <div
            ref="globalGraph"
            id="globalGraph"
            class="graph-container__global-graph"
        ></div>
        <div
            v-if="dailyGraphLength > 0"
            class="graph-container__daily-container__daily-graph"
        >
            <div
                v-for="(item, date) in dailyGraphsData"
                :key="date"
            >
                <div
                    :ref="`dailyGraph-${date}`"
                    class="graph-container__daily-container__daily-graph"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import Plotly from 'plotly.js-basic-dist';
import moment from 'moment';
export default {

    name: 'assetDetails',

    components:{
    },

    props: {
        simulation:{
            type: Object,
            required: true
        }
    },

    data () {
        return {
            globalAsset: null,
            dailyGraphsData: {},
            dailyGraphLength: 0,
        };
    },

    computed:{
    },

    mounted(){
        this.makeGlobalPlotly();
        this.drawGraph();
    },

    methods:{
        makeGlobalPlotly() {
            let x = this.simulation.mesure_data.map(elt => elt.date);
            let y = this.simulation.mesure_data.map(elt => elt.value);
            let datesInAxisX = x.map(dateString => moment(dateString));
            let dateMin = moment.min(datesInAxisX).format('DD/MM/YYYY');
            let dateMax = moment.max(datesInAxisX).format('DD/MM/YYYY');

            let traces = [{
                x: x,
                y: y
            }];
            // Use annotations because yaxis.title cannot be rotated
            let layout = {
                title: `Puissance active du ${dateMin} au ${dateMax}`,
                height: 600,
                width: 700,
                annotations: [{
                    xref: 'paper',
                    yref: 'paper',
                    x: 0,
                    xanchor: 'right',
                    y: 1,
                    text: '',
                    yanchor: 'bottom',
                    showarrow: false,
                }],
                yaxis: {
                    title: 'Puissance (kW)'
                },
                xaxis: {
                    title: 'Date'
                }
            };
            Plotly.newPlot('globalGraph', traces, layout);
            this.$refs.globalGraph.on('plotly_relayout', () => {});
        },
        makeDailyPlotly(date, x, y) {
            let traces = [{
                x: x,
                y: y
            }];
            // Use annotations because yaxis.title cannot be rotated
            let layout = {
                title: moment(date).format('DD/MM/YYYY'),
                height: 600,
                width: 700,
                annotations: [{
                    xref: 'paper',
                    yref: 'paper',
                    x: 0,
                    xanchor: 'right',
                    y: 1,
                    text: '',
                    yanchor: 'bottom',
                    showarrow: false,
                }],
                yaxis: {
                    title: 'Puissance (kW)'
                },
                xaxis: {
                    title: 'Date'
                }
            };
            this.$nextTick(() => {
                let graphElement = this.$refs[`dailyGraph-${date}`][0];
                if (graphElement) {
                    Plotly.newPlot(graphElement, traces, layout, { displayModeBar: false });
                    graphElement.on('plotly_relayout', () => {});
                }
            });
        },
        drawGraph(){
            for (let elt of this.simulation.mesure_data){
                let day = elt.date.split('T')[0];
                if (this.dailyGraphsData.hasOwnProperty(day)){
                    this.dailyGraphsData[day].dates.push(elt.date);
                    this.dailyGraphsData[day].values.push(elt.value);
                }
                else {
                    this.dailyGraphsData[day] = {
                        dates: [elt.date],
                        values: [elt.value]
                    };
                }
            }
            this.$set(this, 'dailyGraphLength', Object.keys(this.dailyGraphsData).length);
            for (let data in this.dailyGraphsData) {
                this.makeDailyPlotly(data, this.dailyGraphsData[data].dates, this.dailyGraphsData[data].values);
            }
        },
    }
};
</script>

<style lang="scss">
.graph-container{
    display: flex;
    flex-wrap: wrap;
    &__daily-container{
        width: 100%;
        &__daily-graph{
            overflow-y: auto;
            max-height: 62rem;
            margin-bottom: 2rem;
        }
        flex-grow: 1;
    }
    &__global-graph{
        margin-bottom: 2rem;
        flex-grow: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/Home/motors/simulations/asset-details.vue